import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AudioModalComponent } from '../audio-modal/audio-modal.component';
import MainScene from '../Scenes/MainScene';
import BaseLevelScene from '../Scenes/BaseLevelScene';
import { GlobalService } from '../services/global.service';
import { MixTape } from 'src/classes/MixTape';
import { UserAudio } from 'infrastructure/lib/src/models/user-audio';

@Component({
  selector: 'app-audio-viewer',
  templateUrl: './audio-viewer.component.html',
  styleUrls: ['./audio-viewer.component.scss'],
})
export class AudioViewerComponent {
  private static modal: HTMLIonModalElement;
  private static modalCtrl: ModalController;

  constructor(private modalCtrl: ModalController) {
    AudioViewerComponent.modalCtrl = this.modalCtrl;
  }

  public static openModal(audioMetadata: UserAudio, scene?: MainScene, displayProfileButton=true) {
    console.log(`AudioModal s3Path: ${audioMetadata.s3Path}`);
    AudioViewerComponent.modalCtrl
      .create({
        component: AudioModalComponent,
        componentProps: {
          scene: scene,
          audioMetadata: audioMetadata,
          displayProfileButton,
        },
        // cssClass: cssClass
      })
      .then((modal) => {
        AudioViewerComponent.modal = modal;
        AudioViewerComponent.modal.present();
        GlobalService.incrementModalCount();
        AudioViewerComponent.modal.onDidDismiss().then(() => {
          GlobalService.decrementModalCount();
        });
      });
  }
}
